<template>
  <b-card no-body class="mb-1 col-12">
    <b-card-header header-tag="header" class="p-1 bg-form" role="tab">
      <b-button
        block
        v-b-toggle="'accordion-degree-' + degree.module.id"
        variant="primary"
        class="font-weight-bold text-left"
      >
        <b-icon icon="circle" v-if="!degree.issueDate && degree.module.id != null"/>
        <b-icon icon="check-circle" v-if="degree.issueDate && degree.module.id != null"/>
          {{ degree.module.title || this.$t('progress.otherTrainings') }}
      </b-button>
    </b-card-header>
    <b-collapse
        :id="'accordion-degree-' + degree.module.id"
        :accordion="'degree'+ degree.module.id"
        role="tabpanel"
        v-model="visible"
    >
      <b-card-body>
        <b-list-group flush>
          <b-list-group-item v-for="module in degree.children" :key="module.id" class="d-flex align-items-left">

            <b-button v-if="module.issueDate !== null"
                      size="sm"
                      variant="transparent"
                      v-b-tooltip.hover
                      disabled>
              <b-icon icon="check-circle"
                      :variant="'success'"
                     />
            </b-button>

              <b-button v-if="degree.issueDate === null && module.issueDate === null && module.participation!==null"
                        size="sm"
                        variant="transparent"
                        v-b-tooltip.hover
                        @click.prevent="goTo(module, degree)"
                        :disabled="module.applyActivity!==null">
                <b-icon :icon="module.participation.status === 'ACCEPTED' ? 'calendar-event-fill' : module.participation.status === 'COMPLETED'? 'calendar-check' :'calendar'"
                        :variant="module.participation.status === 'ACCEPTED' ? 'info' : module.participation.status === 'COMPLETED'? 'success' :'warning'"
                        v-b-tooltip.hover
                        :title="module.participation.status === 'ACCEPTED' ? 'Υπάρχει ορισμένη παρακολούθηση' : module.participation.status === 'COMPLETED'? 'Έχει ολοκληρωθεί η παρακολούθηση' : 'Υπάρχει καταχωρημένη αίτηση'"/>
              </b-button>

              <b-button v-if="degree.issueDate === null && module.issueDate === null && module.applyActivity!==null && module.applyActivity.status!=='FAILED' && module.applyActivity.status!=='ASSIGN_PENDING'"
                        size="sm"
                        variant="transparent"
                        v-b-tooltip.hover
                        @click.prevent="goTo(module, degree)">
                <b-icon :icon="module.applyActivity.status === 'ASSIGN_PENDING' ? 'journal' : 'journal-text'"
                        :variant="module.applyActivity.status === 'ASSIGN_PENDING' ? 'warning' : 'info'"
                        v-b-tooltip.hover
                        :title="module.applyActivity.status === 'ASSIGN_PENDING' ? 'Δεν έχει οριστεί Παραστάτης' : 'Εκκρεμεί ολοκλήρωση'"/>
              </b-button>

              <b-button v-if="degree.issueDate === null && module.issueDate === null && module.participation===null"
                        size="sm"
                        variant="transparent"
                        v-b-tooltip.hover
                        @click.prevent="goTo(module, degree)">
                <b-icon icon="search"
                        title="Αναζήτηση"/>

              </b-button>
              {{ module.module.title }}
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-collapse>
  </b-card>

</template>

<script>
  export default {
    props: {
      degree: Object,
      visible: Boolean
    },
    methods: {
      goTo(module, degree) {
        if (degree.issueDate === null && module.issueDate === null && module.participation===null){
          this.$router.push({ path: "/trainings/apply", query: { moduleId: module.module.id } });
        } else if (module.applyActivity!==null && module.applyActivity.status!=='IN_PROGRESS'){
          this.$router.push({ path: "/apply-activities/" + module.applyActivity.id });
        } else if (module.participation!==null){
          this.$router.push({ path: "/participations", query: { memberId: this.$store.state.userInfo.id }});
        }
        }
    },
  }
</script>